import { useCallback } from 'react';
import { type SearchResults } from 'algoliasearch-helper';

import { CheckboxFilter } from '~/components/BettingInsights/components/Filters/CheckboxFilter';
import {
	type BettingInsightsResultAttribute,
	type EsIndex,
} from '~/configuration/betting-insights/types';

import { trackDateFilterChange } from '../../tracking';

import { transformFieldLabel } from './utils/transformFieldLabel';

export function DateRefinement<TIndex extends EsIndex>({
	attribute,
	isDisabled = false,
	label,
}: {
	attribute: BettingInsightsResultAttribute<TIndex>;
	isDisabled?: boolean;
	label: string;
}) {
	const sortBy = useCallback<
		(a: SearchResults.FacetValue, b: SearchResults.FacetValue) => number
	>((a, b) => (Number(a.escapedValue) < Number(b.escapedValue) ? -1 : 1), []);

	return (
		<CheckboxFilter
			attribute={attribute}
			isDisabled={isDisabled}
			label={label}
			limit={2}
			showMore
			showMoreLimit={20}
			sortBy={sortBy}
			trackChange={value => {
				trackDateFilterChange(value);
			}}
			transformFieldLabel={transformFieldLabel}
		/>
	);
}
